import { Link } from 'react-router-dom';
import GoogleReviewsBadge from '@/components/GoogleReviewsBadge';
import WhatsAppButton from '@/components/WhatsAppButton';
import CampaignHeroForm from '@/components/sections/campaign/CampaignHeroForm';
import { Check, ArrowRight, Phone } from 'lucide-react';
import { HERO, OFFER_HERO_SIZES } from '@/lib/brandImages';

// No entrance animations in the hero: it must show instantly (Google measures it as the main content).

const FEATURES = [
  'Inventories from £120 inc VAT',
  'Detailed, photographic, time-stamped reports',
  'Fully insured: indemnity and public liability',
  'Reports in 24–48 hours, or 4 hours with express',
];

export default function CampaignHero() {
  return (
    <section className="relative min-h-[100svh] flex items-center pt-10 pb-20 md:pt-16 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO.src}
          srcSet={HERO.srcSet}
          sizes={OFFER_HERO_SIZES}
          width={HERO.width}
          height={HERO.height}
          alt="London property interior"
          loading="eager"
          fetchpriority="high"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/50" />
      </div>
      <div className="relative max-w-[1600px] mx-auto w-full px-5 sm:px-6 md:px-10 lg:px-16 py-10 md:py-20">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="on-dark max-w-2xl text-white">
              <p className="caps-label text-orange mb-6">10 years · 20,000 landlords · London &amp; Manchester</p>
              <h1 className="font-display font-extrabold mono-number" style={{ fontSize: 'clamp(2.5rem, 6.5vw, 4.75rem)' }}>
                Property inventories,<br />done properly.
              </h1>
              <ul className="mt-8 space-y-3">
                {FEATURES.map((f) => (
                  <li key={f} className="flex items-center gap-3 text-lg text-white/90">
                    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-orange/20 flex items-center justify-center">
                      <Check className="text-orange" size={16} />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <div className="flex flex-col sm:flex-row gap-4 mt-10">
                <Link to="/request-quote" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-orange text-navy font-semibold rounded-full hover:bg-orange-dark transition-colors">
                  Request Quote <ArrowRight size={20} />
                </Link>
                <Link to="/book-now" className="px-8 py-4 border border-white/30 text-white font-semibold rounded-full hover:bg-white/10 transition-colors text-center">
                  Book Online
                </Link>
              </div>
              <div className="mt-8">
                <p className="text-sm text-white/60">Call us now on</p>
                <a href="tel:02089355492" className="inline-flex items-center gap-2 text-2xl font-bold text-orange hover:text-orange-light transition-colors">
                  <Phone size={22} /> 0208 935 5492
                </a>
              </div>
              <div className="flex flex-wrap items-center gap-4 mt-6">
                <GoogleReviewsBadge variant="dark" />
                <WhatsAppButton label="Chat on WhatsApp" />
              </div>
          </div>
          <div className="hidden lg:flex justify-end self-start lg:pt-24">
            <CampaignHeroForm />
          </div>
        </div>
      </div>
    </section>
  );
}